// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"Footer__ButtonGroup___1Jl_i","Button":"Footer__Button___3zLLG"};